import React, { useState, useContext } from 'react';
import Button from '../button/button';
import { useLocation, useNavigate } from 'react-router-dom';
import LogOutHandler from '../../Apihander/logOut/logoutHandler';
import SidebarContext from '../../contexts/MyContext';
const { detect } = require('detect-browser');

const MobileDashboardHeader = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [menuOpen, setMenuOpen] = useState(false);
  const {user, setPremiumStatus, setIsPolling} = useContext(SidebarContext) 

  const detectbrowser = detect();
  let detectDeviceName = detectbrowser?.name || "unknown";
  // Check for Brave specifics
  if (detectbrowser?.name === 'chrome') {
    // Additional checks for Brave
    if (navigator.brave || window.navigator.userAgent.includes('Brave')) {
      detectDeviceName = 'brave';
    }
  }

  const handleLogOut = async (e) => {
    e.preventDefault()
    try {
      // const payload = {
      //   deviceType: "browser",
      //   deviceName: "chrome"
      // }
      const payload = {
        deviceType:detectbrowser?.type,
        deviceName:detectDeviceName
      }
      const response = await LogOutHandler.doHandelLogOut(payload)
      // console.log(response,'response')
      if (response?.status === 200 || response?.data?.statusCode === 200) {
        navigate("/");
        // setUser(null);
        // setPremiumStatus(null)
        // setActionTabIndex(null)
        // setTabIndex()
        // // setBtnToggl(false)

        // setBtnToggl(false)
        // setIsLoginCancel(true)
        // setRecordingStart(false)

        window.location.reload()


      }


    } catch (error) {
      console.log("🚀 ~ getSetting ~ error:", error)

    }
  };

  // Close menu when clicking outside
  // React.useEffect(() => {
  //   if (!menuOpen) return;
  //   const handleClick = (e) => {
  //     if (!e.target.closest('.mobile-header-menu-popover') && !e.target.closest('.menu-button')) {
  //       setMenuOpen(false);
  //     }
  //   };
  //   document.addEventListener('mousedown', handleClick);
  //   return () => document.removeEventListener('mousedown', handleClick);
  // }, [menuOpen]);

  return (
    <div className="mobile-header-container vr-mheader">

    {/* <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '35px 12px',
      background: '#fff',
      borderBottom: !menuOpen && '1px solid #eee',
      height: 56,
      position: 'sticky',
      top: 5,
      zIndex: 1000
    }}> */}

      <div className="vr-mheader-bar" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 12px',
        background: '#fff',
        borderBottom: !menuOpen && '1px solid #eee',
        height: 56,
        flexShrink: 0,
      }}>

      {/* <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div className="logo-icon" style={{
          background: 'black',
          borderRadius: '50%',
          width: 36,
          height: 36,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 16C14.2091 16 16 14.2091 16 12V6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6V12C8 14.2091 9.79086 16 12 16Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M19 10V12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12V10" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M12 19V22" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        </div>
        <span style={{ color: 'black', fontWeight: 700, fontSize: 18, letterSpacing: 1 }}>VOICE RECORDER</span>
      </div> */}



      {/* <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <img src="/img/logo1.png" alt="Voice-Recorder-Mic" height="44px" width="44px" style={{ borderRadius: '50%' }} />
        <span style={{
          fontFamily: 'Bebas Neue',
          fontWeight: '400',
          fontSize: '36px',
          color: "#0F172A",
          textTransform: 'uppercase',
          lineHeight: 'normal',  // Adjust line height for vertical centering
          marginLeft: '8px'      // Adjust margin for spacing
        }}>
          VOICE RECORDER
        </span>
      </div> */}

        {/* {location?.pathname == "/pricing" && */}
        {location?.pathname == "/pricing" ?

        (  
          // <span>Close click</span>
          (
            <>
                <a
                    className="navbar-brand"
                    onClick={() => {
                        const previousLocation = location.state?.from;
                        if (previousLocation) {
                            navigate(previousLocation);
                        } else {
                            navigate(-1);
                        }
                        setPremiumStatus(null)
                        setIsPolling(false);
                    }}
                    style={{ cursor: "pointer", display: 'flex', alignItems: 'center' }}
                >
                    <button
                        type="button"
                        className="close"
                        style={{
                            width: "35px",
                            borderRadius: "50%", height: "35px",
                            // background: "#F1F5F9",
                            border: "none",
                            // color: "#94A3B8",
                            color: '#000000',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: 'center',
                            // background: "#F1F5F9",
                            background: 'white',
                            // color: "#94A3B8",
                            cursor: "pointer",

                        }}


                    >
                        <span aria-hidden="true" style={{
                            fontSize: "30px", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%",
                            paddingBottom: "2px"
                        }}>&times;</span>
                    </button>
                    {/* <img src="/img/logo1.png" height="44px" width="44px" style={{ borderRadius: '50%' }} /> */}
                    <span style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '600',
                        fontSize: '16px',
                        color: "#0F172A",
                    }}>
                        Close
                    </span>
                </a>

            </>
        )

        ) : 
        (
          <div className="vr-mheader-brand" style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <img src="/img/logo1.png" alt="Voice-Recorder-Mic" height="44px" width="44px" style={{ borderRadius: '50%' }} />
            <span className="vr-mheader-word" style={{
              fontFamily: 'Bebas Neue',
              fontWeight: '400',
              fontSize: '36px',
              color: "#0F172A",
              textTransform: 'uppercase',
              lineHeight: 'normal',  // Adjust line height for vertical centering
              marginLeft: '8px'      // Adjust margin for spacing
            }}>
              VOICE RECORDER
            </span>
            {/* <span style={{ color: 'black', fontWeight: 700, fontSize: 18, letterSpacing: 1 }}>VOICE RECORDER</span> */}
          </div>
        )
          
        }

      
      {/* <div style={{ position: 'relative' }}>
        <button
          className="menu-button"
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'black',
          }}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        </button>
        {menuOpen && (
          <>
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              zIndex: 1999,
              background: 'rgba(0,0,0,0.01)'
            }} />
            <div className="mobile-header-menu-popover" style={{
              position: 'absolute',
              right: 0,
              top: 40,
              background: 'black',
              border: '1px solid #222',
              borderRadius: 12,
              boxShadow: '0 2px 8px #0008',
              padding: 12,
              minWidth: 140,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              zIndex: 2000
            }}>
              {
                !user?.isSubscriptionActive &&
              <button
                style={{
                  background: 'black',
                  color: '#fff',
                  border: '1px solid #fff',
                  borderRadius: 20,
                  padding: '8px 0',
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: 'pointer',
                  marginBottom: 4
                }}
                onClick={() => { setMenuOpen(false); navigate('/pricing'); }}
              >
                Pricing
              </button>
              }

              <button
                style={{
                  background: '#F87171',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 20,
                  padding: '8px 0',
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: 'pointer',
                }}
                onClick={handleLogOut}
              >
                Logout
              </button>
            </div>
          </>
        )}
      </div> */}

      {/*New  Hamburger Menu */}
      <button
        className="vr-mheader-menubtn"
        aria-label="Menu"
        aria-expanded={menuOpen}
        style={{
          background: 'none',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '5px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'black',
          width: '56px',
          height:'40px'
        }}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
      </button>
    </div>

<div
className="vr-mheader-panel"
style={{
    maxHeight: menuOpen ? '400px' : '0px',
    opacity: menuOpen ? 1 : 0,
    transform: menuOpen ? 'translateY(0)' : 'translateY(-10px)',
    transition: 'all 0.4s ease-in-out',
    overflow: 'hidden',
    background: '#fff',
    borderBottom: menuOpen ? '1px solid #eee' : 'none',
    willChange: 'max-height, opacity, transform'
}}
>
{menuOpen && (
    <div className="vr-mheader-list" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        padding: '10px 15px'
    }}>
        {/* Pricing (Centered) */}
        {(!user?.isSubscriptionActive && props?.showPricing) && (
            <div className="vr-mheader-item" style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#000000',
                fontFamily: 'Metropolis'
            }}
                onClick={() => { navigate('/pricing'); setMenuOpen(false); }}
            >
                Pricing
            </div>
        )}

            {props?.showDashboardNavigation &&
              <div className="vr-mheader-item" style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#000000',
                fontFamily: 'Metropolis'
              }}
                onClick={() => { navigate('/dashboard'); setMenuOpen(false); }}
              >
                Go to Dashboard
              </div>
            }

        {/* User Profile */}
        <div className="vr-mheader-item is-logout" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            color: '#64748b'
        }}
            onClick={handleLogOut}
        >
            <img
                src="/img/icon/box-arrow-right.png"
                alt="Logout Icon"
                className="icon"
            />
            <span 
            className="vr-mheader-item-label"
            style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#000000',
                fontFamily: 'Metropolis'
            }}
            >Logout</span>
        </div>
    </div>
)}
</div>

</div>
  );
};

export default MobileDashboardHeader; 